// extracted by mini-css-extract-plugin
export default {"page":"styles_page__J81nG","header":"styles_header__Bu7jd","backButton":"styles_backButton__Tc2b7","content":"styles_content__0OLCE"};